
import { useNavigate } from "react-router-dom";
import { ArrowRight, Check, MessageCircle, Star, Zap } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

interface ChatLimitPopupProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ChatLimitPopup({ isOpen, onOpenChange }: ChatLimitPopupProps) {
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
    navigate("/pricing");
    onOpenChange(false);
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-xl text-center">
            Unlock Unlimited Conversations
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            You've reached your free chat limit. Subscribe to continue learning with MindTube.
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <h4 className="font-medium">With a subscription you get:</h4>
            <ul className="space-y-2">
              <li className="flex items-start gap-2">
                <Check className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <span>Unlimited access to all MindTube features</span>
              </li>
              <li className="flex items-start gap-2">
                <Zap className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <span>Faster response time with priority access</span>
              </li>
              <li className="flex items-start gap-2">
                <Star className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <span>Exclusive AI features for premium users</span>
              </li>
              <li className="flex items-start gap-2">
                <MessageCircle className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <span>Process longer videos without interruption</span>
              </li>
            </ul>
          </div>
        </div>
        
        <AlertDialogFooter className="flex-col sm:flex-col gap-2">
          <Button 
            onClick={handleUpgradeClick} 
            className="w-full gap-2"
          >
            Upgrade Now <ArrowRight className="h-4 w-4" />
          </Button>
          <AlertDialogCancel className="w-full sm:w-full mt-2">
            Maybe Later
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
